const styles = theme => ({
  rootHover: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '40px',
    backgroundColor: '#E3F3FF',
    border: '1px dashed #015FFB',
    borderRadius: '8px',
    gap: 4,
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    minHeight: '161px',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '40px',
    backgroundColor: '#F8FAFC',
    border: '1px dashed #919EAB52',
    borderRadius: '8px',
    gap: 4,
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    minHeight: '161px',
  },
  iconHover: {
    color: '#015FFB',
    fontSize: '24px',
  },
  icon: {
    color: '#002E47',
    fontSize: '24px',
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    marginTop: 16,
  },
})
export default styles
